import { type IPasswordResetResult } from "@/assets/ts/interfaces/password-reset-form/IPasswordResetResult";
import { type IPasswordResetState } from "@/assets/ts/interfaces/password-reset-form/IPasswordResetState";
import { type IPasswordResetFormHandler } from "@/assets/ts/interfaces/password-reset-form/IPasswordResetFormHandler";

export class PasswordResetFormHandler implements IPasswordResetFormHandler {
	private state: Ref<IPasswordResetState> = ref(this.initDefaultStateValues());

	initDefaultStateValues(): IPasswordResetState {
		return {
			email: "",
			isRequestSent: false,
			result: {
				message: "",
				success: false,
			},
		};
	}

	updateRequestStatus(isRequestSent: boolean): void {
		this.state.value.isRequestSent = isRequestSent;
	}

	get getState(): IPasswordResetState {
		return this.state.value;
	}

	get isEmailFormatValid(): boolean {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		return emailRegex.test(this.state.value.email);
	}

	updateResult(result: IPasswordResetResult): void {
		this.state.value.result.message = result.message;
		this.state.value.result.success = result.success;
	}
}
